import { createBrowserRouter } from "react-router-dom";
import BaseLayout from "./components/base-layout";
import SuspenseLoader from "./components/loader/suspense-loader";
import { lazy, Suspense } from "react";

const Loader = (Component: any) => (props: any) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const PageNotFound = Loader(lazy(() => import("./components/page-not-found")));

const HomePage = Loader(lazy(() => import("./contents/homepage")));
const Verify = Loader(lazy(() => import("./contents/verify")));
const WelcomePage = Loader(lazy(() => import("./contents/homepage/welcome")));
const ThankYou = Loader(lazy(() => import("./contents/homepage/thankYou")));
const Preview = Loader(lazy(() => import("./contents/homepage/preview")));

export const router = createBrowserRouter([
  {
    path: "/",
    element: <BaseLayout />,
    errorElement: <PageNotFound />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "/verify", element: <Verify /> },
      { path: "/welcome", element: <WelcomePage /> },
      { path: "/thank-you", element: <ThankYou /> },
      { path: "/preview", element: <Preview /> },
    ],
  },
  {
    path: "*",
    element: <PageNotFound />,
    errorElement: <PageNotFound />,
  },
]);
